import script from "./MatrixRain.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatrixRain.vue?vue&type=script&setup=true&lang=ts"

import "./MatrixRain.vue?vue&type=style&index=0&id=6252afaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6252afaa"]])

export default __exports__